import React from 'react';
import { useAuth } from 'react-oidc-context';
import { Navigate, Outlet } from 'react-router';
import Loader from './01_atoms/Loader/Loader';
import Centered from './01_atoms/Centered/Centered';
import { useUserRoleContext } from '../contexts/UserRoleContext';

export default function AdminRoute() {
  const auth = useAuth();
  const { isLoading: rolesLoading, isAdmin } = useUserRoleContext();

  // Show loader while authenticating
  if (auth.isLoading || !auth.user) {
    return (
      <main>
        <Centered>
          <span>Laden...</span>
          <Loader />
        </Centered>
      </main>
    );
  }

  // Wait for user roles to be loaded
  if (rolesLoading) {
    return (
      <main>
        <Centered>
          <span>Gebruikersgegevens laden...</span>
          <Loader />
        </Centered>
      </main>
    );
  }

  // Check if user has admin role
  if (!isAdmin()) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}